import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
// import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import { Link } from "react-router-dom";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);


  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg mt-0 md:mt-10" style={y > 100 ? { height: "60px", marginTop: "0px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="/" smooth={true}>
            <img src="adoni/logo/cranebufferlogo.jpeg" className="w-24 h-14"></img>
            <h1 className="font-bold text-2xl text-blue-800">Crane Buffer</h1>
          </Link>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/" spy={true} smooth={true} offset={-80}>
                Home
              </Link>
            </li>
            <Link to="/About" className="semiBold font15 pointer">
              <p style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                About
              </p>
            </Link>
            <Link to="/Service" className="semiBold font15 pointer">
              <p style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                Service
              </p>
            </Link>
            <Link to="/products" className="semiBold font15 pointer">
              <p style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                Products
              </p>
            </Link>
            <Link to="/facility" className="semiBold font15 pointer">
              <p style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                Facilities
              </p>
            </Link>
            <Link to="/news-event-blog" className="semiBold font15 pointer">
              <p style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                News & Blog
              </p>
            </Link>
       
            <li className="semiBold font15 pointer">
              <Link to='/contact-us' style={{ padding: "10px 15px" }} spy={true} smooth={true} offset={-80}>
                Contact
              </Link>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">

            <li className="semiBold font15 pointer flexCenter">
              <a href="https://calculation.cranebuffer.com" className="radius8 lightBg" style={{ padding: "10px 15px" }} target="_blank" rel="noopener noreferrer">
                Login Now
              </a>
            </li>
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


